export function wrap(object: object) {
    return {
        data: {
            attributes: object,
        },
    };
}
